import { Injectable, Injector, computed, inject, signal } from '@angular/core';
import { PageListConfig } from 'src/app/configs/page-list.config';
import { AppTabPageData } from '../models/tab-page-data.model';
import { RoutingStateService } from './routing-state.service';

@Injectable({
  providedIn: 'root',
})
export class DynamicTabService {
  routingStateService = inject(RoutingStateService);
  #newTabName = signal<string>('dashboard'); //مقدار اولیه
  #currentTabs = signal<string[]>(['dashboard']);
  closeTab = signal<boolean>(false);
  #activeTab = signal<string>('');
  // activeTab = toObservable(this.#activeTab);
  currentTabs = computed(this.#currentTabs);
  activeTab = computed(this.#activeTab);

  setActiveTab(tabName: string) {
    this.closeTab.set(false);
    this.#activeTab.set(tabName);
  }

  constructor(private injector: Injector) {}

  setNewTab(tabName: string) {
    this.#newTabName.set(tabName);
  }

  getNewTab(): string {
    return this.#newTabName();
    // return toObservable(this.newTabName, {
    //   injector: this.injector,
    // });
  }

  public setCurrentTabs(tabs: string[]): void {
    this.#currentTabs.set(tabs);
  }

  /** گرفتن دیتای تبی که قرار بازبشه مثل نام ، کامپوننتش از فایل کانفیگ تب ها  */
  getTabPageData(tabName: string): AppTabPageData {
    if (this.routingStateService.isMultipleTabs(tabName.split('?')[0]))
      return PageListConfig.find((tab) => tab.name === tabName.split('?')[0]);
    else return PageListConfig.find((tab) => tab.name === tabName);
  }

  /** چک کردن اینکه این تب قبلا باز شده ؟  */
  isExistTab(tabName: string): boolean {
    let isExit: boolean = false;

    const tab = this.currentTabs().find((tab) => tab === tabName);
    if (tab) isExit = true;

    return isExit;
  }
}
